import { render, staticRenderFns } from "./backtotop.vue?vue&type=template&id=92426e3c&scoped=true&"
import script from "./backtotop.vue?vue&type=script&lang=js&"
export * from "./backtotop.vue?vue&type=script&lang=js&"
import style0 from "./backtotop.vue?vue&type=style&index=0&id=92426e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92426e3c",
  null
  
)

export default component.exports